import { Component, OnInit, AfterViewInit } from '@angular/core';
import { LoginService } from '../login/login.service';
import { LayersService } from '../_services/layers.service';

import { Mapapi } from '../ol-map/mapapi';
import { ActivatedRoute, Params, Router } from '@angular/router';
@Component({
    selector: 'app-app-menu',
    templateUrl: './app-menu.component.html',
    styleUrls: ['./app-menu.component.css'],
    standalone: false
})
export class AppMenuComponent implements OnInit, AfterViewInit {

    obList: any = [];
    selectedOb: any;


    constructor(
        private loginService: LoginService,
        private layerService: LayersService,
        private api: Mapapi,
        private router: Router,
        private activeRouter: ActivatedRoute
    ) {


    }

    public refresh() {
        this.layerService.selectLayersGroup(this.selectedOb);
    }

    public obChange(event: any): void {
        // console.log("menu change");
        //console.warn(event.value);
        // this.changeRouteQueryParam(event.value.ob_uime);
        this.layerService.selectLayersGroup(event.value);
    }

    ngAfterViewInit() {
        this.activeRouter.queryParams.subscribe(params => {
            const location = params["location"];

            this.api.onMapLoad().subscribe(api => {
                //console.log("menu init!");
                //console.log( this.loginService.getPermissions() );
                this.loginService.getPermissions((permissions: any[]) => {

                    const perm = permissions[1];

                    if (perm.length > 0) {
                        this.layerService.selectLayersGroup(perm[0]);
                    }

                    for (const p of perm) {
                        this.obList.push({
                            label: p.ob_uime,
                            value: {
                                ob_uime: p.ob_uime,
                                ob_mid: p.ob_mid,
                                ob_mids: p.ob_mids,
                                privilege: p.privilege,
                                wkt_extent: p.wkt_extent
                            }
                        });
                    }

                    this.selectedOb = this.obList[0].value;

                });

            })

        })
    }


    ngOnInit() {
    }


    // changeRouteQueryParam(location: string): void {
    //     const queryParams: Params = { location:  location};
    //     this.router.navigate(
    //         [],
    //         {
    //             relativeTo: this.activeRouter,
    //             queryParams: queryParams,
    //             queryParamsHandling: 'merge', // remove to replace all query params by provided
    //         });
    // }

}
